import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { IBoletinConcursalCreateReportResponse } from 'src/app/interface/IBoletinConcursalCreateReportResponse';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';

export interface DatosProcedimientoElement {
  name: string;
  value: any;
}

export interface TableDetalleElement {
  nombrePublicacion: string;
  fchPublicacion: string;
  entePublicador: string;
}

@Component({
  selector: 'app-boletin-concursal-report-viewer',
  templateUrl: './boletin-concursal-report-viewer.component.html',
  styleUrls: ['./boletin-concursal-report-viewer.component.scss']
})
export class BoletinConcursalReportViewerComponent {
  @Input() content!: IBoletinConcursalCreateReportResponse;
  @Input() showHeader: boolean = true;

  @Output() descargarTX = new EventEmitter<string>();

  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatPaginator) paginator!: MatPaginator;

  dataSource = new MatTableDataSource<TableDetalleElement>();
  public datosProcedimiento: DatosProcedimientoElement[] = [];
  public verDetalle: boolean = false;
  displayedColumns: string[] = ['name', 'value'];
  public header: string[] = [
    'nombrePublicacion',
    'fchPublicacion',
    'entePublicador'
  ];
  public tableDetalle: TableDetalleElement[] = [];
  public listaDetalles: any[] | null = null;

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  constructor(
  ) { }

  ngOnInit(): void {
    this.setDatosProcedimiento();
    this.listaDetalles = this.content?.boletinConcursalReporte?.principal?.encabezado?.detalles || [];
  }

  setDatosProcedimiento() {
    const rut = this.content?.boletinConcursalReporte?.principal?.encabezado?.rut + '-' + this.content?.boletinConcursalReporte?.principal?.encabezado?.dv;
    this.datosProcedimiento = [
      {name: "Tipo de Procedimiento", value: this.content?.boletinConcursalReporte?.principal?.encabezado?.tipoDeProcedimiento},
      {name: "Rut Deudor", value: rut},
      {name: "Nombre / Razón Social Deudor", value: this.content?.boletinConcursalReporte?.principal?.encabezado?.razonSocial},
      {name: "Tribunal", value: this.content?.boletinConcursalReporte?.principal?.encabezado?.tribunal},
      {name: "Rol Causa", value: this.content?.boletinConcursalReporte?.principal?.encabezado?.rolCausa},
      {name: "Liquidador", value: this.content?.boletinConcursalReporte?.principal?.encabezado?.liquidador},
    ];
  }

  setDetalles() {
    if(!this.verDetalle) {
      this.verDetalle = true;
      if(this.content?.boletinConcursalReporte?.principal?.encabezado?.detalles && this.content?.boletinConcursalReporte?.principal?.encabezado?.detalles.length > 0) {
        this.listaDetalles = this.content?.boletinConcursalReporte?.principal?.encabezado?.detalles || [];
        this.dataSource = new MatTableDataSource<TableDetalleElement>(this.listaDetalles);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      }
    } else {
      this.verDetalle = false;
    }
  }

  descargarPDF(): void {
    const tx = this.content?.boletinConcursalReporte?.datosBasicosSolicitud?.IDTransaccion || '';
    console.log('tx', tx);
    if(tx) {
      this.descargarTX.emit(tx);
    }
  }

}
